export const PARAGRAPH_TAG_NAME = 'p';
